<template>
  <div class="bg">
    <headTop style="position:absolute;top:50px;width:100%;" :getleft="showArrow" :showUser="showUser" :isHome="Home"></headTop>
    <div class="title_bg">综合营运管理平台</div>
    <systemIn></systemIn>
    <role></role>
  </div>
</template>
<script>
import headTop from "../../components/headTop.vue";
import systemIn from "../systemIn.vue";
import role from "../role.vue";
export default {
  data() {
    return {
      Home:true,
      xtlist: [],
      showArrow: false,
      showUser: true,
    };
  },

  components: { headTop, systemIn, role },
};
</script>
<style>
.bg {
  background: url("../../assets/bg.png") no-repeat;
  position: fixed;
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
}
.title_bg {
  width: 946px;
  height: 124px;
  background: url("../../assets/title_bg.png") no-repeat center center;
  margin: 0 auto;
  text-align: center;
  font-size: 50px;
  color: #fff;
  line-height: 120px;
  margin-top: 27px;
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/view/home/index.vue